module.exports = {
      id: "rte:bold-usage",
      viewBox: "0 0 384 512",
      url: "/static/" + "sprites.1e5806fb7235408b9281f0924c9110c8.svg#rte:bold-usage",
      toString: function () {
        return this.url;
      }
    }